export const URLS = {
  ORDER_API: "https://order.sit.sofology.co.uk",
  SOFOLOGY_HOME: "https://www.sit.sofology.co.uk",
  SOFOLOGY_REX: "https://api.sit.sofology.co.uk/api/rex/",
  SOFOLOGY_API: "https://api.sit.sofology.co.uk/api/",
  MY_SOFOLOGY_LOGIN: "https://www.sit.sofology.co.uk/my-sofology-login/",
  MY_SOFOLOGY_API: "https://customerexperience.sit.sofology.co.uk/api/",
  SOP_API: "https://salesorderprocessing.sit.sofology.co.uk/api/",
  TEMPLATES_ENDPOINT: {
    GET_ALL:
      "https://dev-www-my-sofology-co-uk.euwest01.umbraco.io/umbraco/api/MetaData/GetContentGroupedByTemplate",
  },
  MY_ACCOUNT_URL: "https://myaccount.sit.sofology.co.uk/api/",
  MY_ACCOUNT_LOGOUT_URL: "https://myaccount.sit.sofology.co.uk/Logout/",
  BASKET_URL: "https://www.sit.sofology.co.uk/basket",
  HYBRIS_OAUTH_TOKEN:
    "https://sit.g.sofology.co.uk/swkcommercewebservices/oauth/token",
  HYBRIS_COMMERCE:
    "https://sit.g.sofology.co.uk/swkcommercewebservices/v2/cmsSofaworksSite/",
  PAYPAL: {
    ENV: "sandbox",
    CLIENT: {
      sandbox:
        "AbdzWd3vpYMFTnAKFbZtcFnsOiKrivYlFazcm6gL_rkpylkZGjK2UytYCf0EwwrgtGGT952L7XOLOL0l",
      production:
        "AdWII6CQL0_7ALJl7KnyS4nBjFdpuo--PCmqJLgpdEaDzKkl26WeCZI52yD5flgKfsfkch1YDuYxMGxZ",
    },
  },
  ADYEN: {
    CUSTOMER_CREATE_PAYMENT_SESSION: "https://api.sit.sofology.co.uk/api/payments/create-payment-session",
    SOFOLOGIST_CREATE_PAYMENT_SESSION: "https://portalapi.sit.sofology.co.uk/api/payments/create-payment-session-as-sofologist",
    REDIRECT_URL: "https://my.sit.sofology.co.uk/",
    ENVIRONMENT: 'test',
    CLIENT_KEY: 'test_IITAUQZOB5HVFGQY6SYJC3NGYI6DKSUS',
  }
};

export const APP_INFO = {
  ENV: "DEV",
  CLIENT_ID:
    "125377059059-mn1rb1eku9lhecb5vn0rq8145nouftld.apps.googleusercontent.com",
  COOKIE_DOMAIN: ".dev.sofology.co.uk",
  SHOW_ALT_DELIVEY_COVID_MESSAGE: false,
};



// WEBPACK FOOTER //
// ./src/config/DEV.config.js